import { IPersonWidgetInfo } from '@modules/production/policy/page/tabs/policy-persons-tab';

export const validateField = (
  fieldName: keyof IPersonWidgetInfo,
  value: unknown,
  lineExternalCode: string
): string => {
  if (fieldName === 'fullName' && !value) {
    return 'Required';
  }
  if (
    fieldName === 'relation' &&
    ['19', '48'].includes(lineExternalCode) &&
    !value
  ) {
    return 'Required';
  }
  if (
    fieldName === 'dateOfBirth' &&
    ['43', '6', '19', '48'].includes(lineExternalCode) &&
    !value
  ) {
    return 'Required';
  }
  if (
    fieldName === 'gender' &&
    ['43', '6', '19', '48'].includes(lineExternalCode) &&
    !value
  ) {
    return 'Required';
  }
  if (
    fieldName === 'nationalityOneCode' &&
    lineExternalCode === '43' &&
    !value
  ) {
    return 'Required';
  }
  if (fieldName === 'countryCode' && !value) {
    return 'Required';
  }
  if (fieldName === 'city' && !value) {
    return 'Required';
  }
  if (
    fieldName === 'occupationClassCode' &&
    lineExternalCode === '43' &&
    !value
  ) {
    return 'Required';
  }
  return '';
};

export const validateForm = (
  policyPersons: IPersonWidgetInfo[],
  lineExternalCode: string
): { errors: Record<number, Record<string, string>>; valid: boolean } => {
  let valid = true;
  const newErrors: Record<number, Record<string, string>> = {};
  policyPersons.forEach((person, index) => {
    const personErrors: Record<string, string> = {};
    let errorMessage = validateField(
      'fullName',
      person.fullName,
      lineExternalCode
    );
    if (errorMessage) {
      personErrors.fullName = errorMessage;
      valid = false;
    }
    if (['19', '48'].includes(lineExternalCode)) {
      errorMessage = validateField(
        'relation',
        person.relation,
        lineExternalCode
      );
      if (errorMessage) {
        personErrors.relation = errorMessage;
        valid = false;
      }
    }
    if (['43', '6', '19', '48'].includes(lineExternalCode)) {
      errorMessage = validateField(
        'dateOfBirth',
        person.dateOfBirth,
        lineExternalCode
      );
      if (errorMessage) {
        personErrors.dateOfBirth = errorMessage;
        valid = false;
      }
    }
    errorMessage = validateField(
      'phoneNumber',
      person.phoneNumber,
      lineExternalCode
    );
    if (errorMessage) {
      personErrors.phoneNumber = errorMessage;
      valid = false;
    }
    if (['43', '6', '19', '48'].includes(lineExternalCode)) {
      errorMessage = validateField('gender', person.gender, lineExternalCode);
      if (errorMessage) {
        personErrors.gender = errorMessage;
        valid = false;
      }
    }
    if (lineExternalCode === '43') {
      errorMessage = validateField(
        'nationalityOneCode',
        person.nationalityOneCode,
        lineExternalCode
      );
      if (errorMessage) {
        personErrors.nationalityOneCode = errorMessage;
        valid = false;
      }
      errorMessage = validateField(
        'occupationClassCode',
        person.occupationClassCode,
        lineExternalCode
      );
      if (errorMessage) {
        personErrors.occupationClassCode = errorMessage;
        valid = false;
      }
    }
    errorMessage = validateField(
      'countryCode',
      person.countryCode,
      lineExternalCode
    );
    if (errorMessage) {
      personErrors.countryCode = errorMessage;
      valid = false;
    }
    errorMessage = validateField('city', person.city, lineExternalCode);
    if (errorMessage) {
      personErrors.city = errorMessage;
      valid = false;
    }
    if (Object.keys(personErrors).length > 0) {
      newErrors[index] = personErrors;
    }
  });
  return { errors: newErrors, valid };
};

export const validateBeneficiaryField = (
  fieldName: keyof IPersonWidgetInfo,
  value: unknown
): string => {
  if (fieldName === 'fullName' && !value) {
    return 'Required';
  }

  if (fieldName === 'countryCode' && !value) {
    return 'Required';
  }
  if (fieldName === 'city' && !value) {
    return 'Required';
  }

  return '';
};

export const validateBeneficiaryForm = (
  policyPersons: IPersonWidgetInfo[],
  lineExternalCode: string
): { errors: Record<number, Record<string, string>>; valid: boolean } => {
  let valid = true;
  const newErrors: Record<number, Record<string, string>> = {};
  policyPersons.forEach((person, index) => {
    const personErrors: Record<string, string> = {};
    let errorMessage = validateBeneficiaryField('fullName', person.fullName);
    if (errorMessage) {
      personErrors.fullName = errorMessage;
      valid = false;
    }

    errorMessage = validateBeneficiaryField('countryCode', person.countryCode);
    if (errorMessage) {
      personErrors.countryCode = errorMessage;
      valid = false;
    }
    errorMessage = validateBeneficiaryField('city', person.city);
    if (errorMessage) {
      personErrors.city = errorMessage;
      valid = false;
    }
    if (Object.keys(personErrors).length > 0) {
      newErrors[index] = personErrors;
    }
  });
  return { errors: newErrors, valid };
};
